import { Spacer, Text } from "@hackthenorth/north";
import {
  ClipboardDocumentCheckIcon,
  ClipboardIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import styled from "styled-components";

import { Modal } from "src/shared/components";
import { BalanceChip } from "src/views/goose-games/components/balanceChip";

import FooterActions from "../../../../footerActions";

export interface MarkModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  markComplete: boolean;
  name: string;
  bucks: number;
  quest: string;
}
const MarkModal: React.FC<MarkModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  markComplete,
  name,
  bucks,
  quest,
}) => {
  return (
    <Modal isOpen={isOpen}>
      <HeaderContainer>
        {markComplete ? (
          <>
            <HeaderIcon>
              <ClipboardDocumentCheckIcon />
            </HeaderIcon>
            <Text mods="h3 bold">Mark &quot;Complete&quot;</Text>
          </>
        ) : (
          <>
            <HeaderIcon>
              <ClipboardIcon />
            </HeaderIcon>
            <Text mods="h3 bold">Mark &quot;Not Complete&quot;</Text>
          </>
        )}
      </HeaderContainer>
      <TextWrapper>
        <Text mods="grey medium">Are you sure you want to mark</Text>
        <Text mods="grey medium">
          {quest} as
          <CompleteLabel markComplete={markComplete}>
            {markComplete ? "Complete" : "Not Complete"}
          </CompleteLabel>
          ?
        </Text>
        <RewardContainer>
          {markComplete ? (
            <Text mods="grey medium">
              This will reward <NameLabel>{name}</NameLabel> with
            </Text>
          ) : (
            <Text mods="grey medium">
              This will decrease <NameLabel>{name}</NameLabel>&apos;s balance by
            </Text>
          )}

          <BalanceChip points={bucks} />
        </RewardContainer>
      </TextWrapper>

      <Spacer height={24} />
      <FooterActions
        confirmText={"Confirm"}
        onConfirm={onConfirm}
        onCancel={onCancel}
      />
    </Modal>
  );
};

export default MarkModal;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
  gap: 8px;
`;

const HeaderIcon = styled.div<{ backgroundColor?: string }>`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CompleteLabel = styled.span<{ markComplete: boolean }>`
  color: ${({ markComplete, theme }) =>
    markComplete
      ? theme.globalConstants.color.textSuccess
      : theme.globalConstants.color.textSecondary};
  background-color: ${({ markComplete, theme }) =>
    markComplete
      ? theme.globalConstants.color.backgroundSuccessLight
      : theme.globalConstants.color.backgroundGrayDark};
  margin: 0 8px;
  border-radius: 50px;
  padding: 4px 8px;
  font-weight: bold;
`;

const NameLabel = styled.span`
  font-weight: bold;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
`;

const RewardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
